import React from 'react';
import { Space, Tabs, Typography } from 'antd';
import { BankOutlined, BarChartOutlined, ToolOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth } from '../store/hooks';
import AdminUsersTab from './admin/AdminUsersTab';
import AdminCompaniesTab from './admin/AdminCompaniesTab';
import AdminMigrationsTab from './admin/AdminMigrationsTab';
import AdminGenerationsTab from './admin/AdminGenerationsTab';

const { Title } = Typography;

const AdminCenterPage: React.FC = () => {
  const claims = useAuth().claims;

  if (!claims?.superadmin) {
    return <div />; // Hidden from non-superadmins
  }

  return (
    <Space direction="vertical" style={{ width: '100%' }} size="large">
      <Title level={3}>Admin Center</Title>

      <Tabs
        defaultActiveKey="users"
        items={[
          {
            key: 'users',
            label: (
              <Space size={6}>
                <UserOutlined />
                <span>Users</span>
              </Space>
            ),
            children: <AdminUsersTab />,
          },
          {
            key: 'companies',
            label: (
              <Space size={6}>
                <BankOutlined />
                <span>Companies</span>
              </Space>
            ),
            children: <AdminCompaniesTab />,
          },
          {
            key: 'generations',
            label: (
              <Space size={6}>
                <BarChartOutlined />
                <span>Generations</span>
              </Space>
            ),
            children: <AdminGenerationsTab />,
          },
          {
            key: 'migrations',
            label: (
              <Space size={6}>
                <ToolOutlined />
                <span>Migrations</span>
              </Space>
            ),
            children: <AdminMigrationsTab />,
          },
        ]}
      />
    </Space>
  );
}

export default AdminCenterPage;
